const register = {
  validating: {
    title: "Validating Invitation",
  },
  titleInvitation: "Complete Your Registration",
  titleDefault: "Create Account",
  invitationBanner: {
    prefix: "You are invited to join as a",
    forOrganization: "for organization",
    defaultOrganization: "your organization",
  },
  form: {
    emailLabel: "Email Address *",
    emailInvitationLocked: "This email is set by your invitation and cannot be changed",
    emailHint: "Use your institutional email address",
    nameLabel: "Full Name *",
    institutionLabel: "Your Affiliation *",
    fromInvitation: "(from invitation)",
    institutionPlaceholder: "e.g., Reykjavik University Hospital",
    institutionInvitationLocked: "Your organization is set by your invitation and cannot be changed",
    institutionHint: "Where you work (university, hospital, research center, etc.)",
    passwordLabel: "Password *",
    passwordHint: "Minimum 8 characters",
    confirmPasswordLabel: "Confirm Password *",
  },
  submitting: "Creating Account...",
  submit: "Complete Registration",
  signInLink: "Already have an account? Sign In",
  errors: {
    invalidInvitation: "Invalid invitation link",
    missingFields: "All required fields must be filled",
    piEmailRequired: "Please provide your Principal Investigator's email address. They will review and approve your access request.",
    passwordMismatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 8 characters long",
    registrationFailed: "Registration failed",
  },
};

export default register;
